import { render, staticRenderFns } from "./bottom-section.vue?vue&type=template&id=b1bbba8a&"
import script from "./bottom-section.vue?vue&type=script&lang=js&"
export * from "./bottom-section.vue?vue&type=script&lang=js&"
import style0 from "./bottom-section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrustpilotReviews: require('/usr/src/app/components/common-sections/trustpilot-reviews.vue').default})
